/**
 * Stamps "Page i of N" on every page of a jsPDF document.
 *
 * Extracted from quotePdfGenerator.js and cciQuotePdfGenerator.js, which each
 * carried their own copy at slightly different offsets. The two presets below
 * preserve those offsets exactly so the standalone PDFs are unchanged; the
 * combined document (CONF-186) uses VDURA_FOOTER throughout.
 *
 * Call this AFTER all content is drawn — the page count is read at stamp time.
 */
export const VDURA_FOOTER = { rightMargin: 20, bottomMargin: 10, color: [128, 128, 128], fontSize: 8 };
export const CCI_FOOTER = { rightMargin: 15, bottomMargin: 8, color: [100, 100, 100], fontSize: 8 };

export function stampPageNumbers(doc, { rightMargin, bottomMargin, color, fontSize }) {
  const totalPages = doc.internal.getNumberOfPages();

  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(fontSize);
    doc.setTextColor(...color);
    doc.text(
      `Page ${i} of ${totalPages}`,
      doc.internal.pageSize.width - rightMargin,
      doc.internal.pageSize.height - bottomMargin,
      { align: 'right' }
    );
  }

  // Reset so any subsequent drawing is not silently grey.
  doc.setTextColor(0, 0, 0);
}
